import React, { useEffect, useRef } from 'react';

const MapWithRoute = ({ pickupDetails, dropDetails, googleMapsApiKey }) => {
  // console.log('✌️pickupDetails --->', pickupDetails);
  // console.log('✌️dropDetails --->', dropDetails);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!pickupDetails || !dropDetails) return;

    const { lat: pickupLat, lng: pickupLng } = pickupDetails;
    const { lat: dropLat, lng: dropLng } = dropDetails;

    const initializeMap = () => {
      // Create the map
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: pickupLat, lng: pickupLng },
        zoom: 12,
      });

      // Initialize Directions Service and Renderer
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer();
      directionsRenderer.setMap(map);

      // Define the route
      const routeRequest = {
        origin: { lat: pickupLat, lng: pickupLng },
        destination: { lat: dropLat, lng: dropLng },
        travelMode: window.google.maps.TravelMode.DRIVING,
      };

      // Fetch and display the route
      directionsService.route(routeRequest, (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          directionsRenderer.setDirections(result);
        } else {
          // console.error('Directions request failed due to:', status);
        }
      });
    };

    // Load Google Maps script
    const loadGoogleMapsScript = () => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = initializeMap;
      document.body.appendChild(script);
    };

    if (!window.google) {
      loadGoogleMapsScript();
    } else {
      initializeMap();
    }
  }, [pickupDetails, dropDetails, googleMapsApiKey]);

  return <div ref={mapRef} className="rounded-xl h-60 w-full" />;
};

export default MapWithRoute;
